import { render, staticRenderFns } from "./BuhReport.vue?vue&type=template&id=16487ab8&scoped=true&"
import script from "./BuhReport.vue?vue&type=script&lang=js&"
export * from "./BuhReport.vue?vue&type=script&lang=js&"
import style0 from "./BuhReport.vue?vue&type=style&index=0&id=16487ab8&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16487ab8",
  null
  
)

export default component.exports